// extracted by mini-css-extract-plugin
export default {"container__actions":"VerticalActions_container__actions__Kzy6N","actions":"VerticalActions_actions__VZEv+","btn":"VerticalActions_btn__Q9Gs-"};